/**
 * The ledger out as a spreadsheet: what the list is showing — all of it, when
 * nothing narrows it — as CSV (lib/csv.js), downloaded. The header row speaks
 * the app's language; the figures are plain numbers with a dot, which every
 * spreadsheet reads.
 */
import { anyFilter, rowsForExport } from './index'
import { saveFile } from './backup'
import { state, toast } from './state'
import { t } from './i18n'
import { today } from '../lib/dates'
import { CSV_BOM, toCsv } from '../lib/csv'

export function exportCsvText(rows) {
  return toCsv(
    [
      t('export.date'),
      t('export.description'),
      t('export.amount', { currency: state.settings.currency }),
      t('export.category'),
      t('export.tags'),
      t('export.paymentType'),
      t('export.notes'),
      t('export.status'),
    ],
    rows.map((r) => [
      r.date,
      r.description,
      Math.round(r.amount * 100) / 100,
      r.category,
      r.tags,
      r.payment_type,
      r.notes,
      r.settled === 0 ? t('export.pending') : '',
    ]),
  )
}

/** Downloads the view as `okane-YYYY-MM-DD.csv` (`-filtered` when it is narrowed). */
export async function exportCsv() {
  const rows = await rowsForExport()
  if (!rows.length) {
    toast(t('export.nothing'), 'warn')
    return 0
  }
  const name = `okane-${today()}${anyFilter.value || state.ui.search.trim() ? '-filtered' : ''}.csv`
  saveFile(CSV_BOM + exportCsvText(rows), name, 'text/csv;charset=utf-8')
  toast(t('export.done', { count: rows.length }), 'good')
  return rows.length
}
